<div class="mb-3 document-upload-section">
    <label *ngIf="label" [for]="inputId" appRequiredField="{{inputId}}" class="document-upload-label form-label fw-bold">
      {{ label }}<span *ngIf="isRequired" style="color: red;">*</span>
    </label>

    <!-- Drag-and-drop or click area to upload files -->
    <div class="drag-and-drop-area p-2 form-control bg-light" (click)="triggerFileInput($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" [ngClass]="{'disabled-upload': formControl.disabled}">
        <label [for]="inputId">{{ placeholderText }}</label>
        <input #fileInput [id]="inputId" type="file" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.gif" [disabled]="disabled" (click)="$event.stopPropagation()" (change)="onFileSelected($event)" [attr.multiple]="multiple ? '' : null" [attr.required]="isRequired ? true : null"
            hidden [attr.aria-label]="label + (isRequired ? ' (required)' : '')">
    </div>

    <!-- Validation message for required field -->
    <div *ngIf="isRequired && uploadedFiles.length === 0 && formControl.touched" class="text-danger mt-2">
        This field is required. Please upload at least one file.
    </div>

    <!-- Uploaded files display area -->
    <div *ngFor="let file of uploadedFiles" class="files-area p-2 mt-3 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center flex-grow-1">
            <div class="uploaded-files me-2">
                <!-- SVG icon for file -->
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.66625 22.7676H17.3334C19.4128 22.7676 20.4474 21.7129 20.4474 19.6236V10.5032H13.175C11.8892 10.5032 11.2867 9.89036 11.2867 8.60465V1.23193H6.66625C4.5971 1.23193 3.55225 2.2965 3.55225 4.38622V19.6236C3.55225 21.7228 4.5971 22.7676 6.66625 22.7676ZM13.2054 9.12708H20.3368C20.2665 8.71522 19.9751 8.31322 19.5032 7.82122L13.9584 2.18636C13.4964 1.70422 13.0747 1.41279 12.6525 1.34208V8.58493C12.6525 8.94622 12.8437 9.12708 13.2054 9.12708Z" fill="#532E60"></path>
                </svg>
            </div>
            <div class="file-name me-3">{{ file.name }}</div>
            <div class="file-link me-3">
                <a href="#" (click)="previewFile(file); $event.preventDefault();" class="underline">Preview</a>
            </div>
            <div class="file-size">{{ getFileSize(file.size) }}</div>
        </div>
        <div class="file-actions" *ngIf="!disabled">
            <button type="button" class="btn btn-sm file-remove-btn" (click)="removeFile(file)" title="Remove file">
                <i class="fas fa-times"></i>
            </button>
        </div>
    </div>
</div>
